import React from 'react'
import classNames from 'classnames'

export const CreditLineNotice = (props) => {
  const {
    notice: {
      message,
      notice_type,
      call_to_action:{
        text,
        url
      } = {}
    } = {},
    close = () => {}
  } = props
  if(!props.notice) return null
  const buttonStyle = classNames({
    button: true,
    'button--primary': true
  })
  return(
    <div styleName='sticky-alert__banner sticky-alert__banner--warning' >
        <div styleName="sticky-alert__wrap">
            <div styleName="sticky-alert__icon" onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              close(notice_type)
            }}>
                <a href="javascript:void(0)">
                    <svg role="img" styleName="sticky-alert__icon-close">
                        <use xlinkHref="#icon-alert-close"></use>
                    </svg>
                </a>
            </div>
            <div styleName="sticky-alert__message">{message}</div>
            <div styleName="sticky-alert__cta">
              <a href="javascript:void(0)" styleName="button button--alert" rel="close" onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
                close(notice_type)
              }}>
                <span>Close</span>
                <svg role="img" styleName="icon-arrow">
                  <use xlinkHref="#icon-arrow-right"></use>
                </svg>
              </a>
              <a href={url} styleName={buttonStyle}>
                <span>{text}</span>
                <svg role="img" styleName="icon-arrow">
                  <use xlinkHref="#icon-arrow-right"></use>
                </svg>
              </a>
            </div>
        </div>
    </div>
  )
}

export class AlertContainer extends React.Component{

  getCta(notice, loan_id, noticeCta){
    const {
      message,
      call_to_action,
      visual_priority,
      resource: { type } = {},
      action:   { name } = {}
    } = notice
    if(!call_to_action) return null
    const buttonStyle = classNames({
      button: true,
      'button--alert': visual_priority === 'error',
      'button--primary': visual_priority === 'warning'
    })
    return(
      <a href={noticeCta(name, type, loan_id)} styleName={buttonStyle}>
        <span>{call_to_action}</span>
        <svg role="img" styleName="icon-arrow">
          <use xlinkHref="#icon-arrow-right"></use>
        </svg>
      </a>
    )
  }

  render(){
    const {
      notices = [],
      close = () => {},
      noticeCta = () => {},
      products: [{id} = {}, ...rest] = [],
      components:{
        AdditionalNotice = () => null
      } = {}
    } = this.props
    return(
      <div styleName="sticky-alert">
        {notices.map((notice, index) => {
          const {
            message,
            call_to_action,
            visual_priority,
            resource: { type } = {},
            action:   { name } = {}
          } = notice
          const styleName = classNames({
            'sticky-alert__banner': true,
            'sticky-alert__banner--warning': visual_priority === 'warning',
            'sticky-alert__banner--error': visual_priority === 'danger'
          })
          return(
            <div styleName={styleName} key={index} >
                <div styleName="sticky-alert__wrap">
                    <div styleName="sticky-alert__icon" onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      close(index)
                    }}>
                        <a href="javascript:void(0)">
                            <svg role="img" styleName="sticky-alert__icon-close">
                                <use xlinkHref="#icon-alert-close"></use>
                            </svg>
                        </a>
                    </div>
                    <div styleName="sticky-alert__message">{message}</div>
                    <div styleName="sticky-alert__cta">
                      <a href="javascript:void(0)" styleName="button button--alert" rel="close" onClick={(event) => {
                        event.preventDefault()
                        event.stopPropagation()
                        close(index)
                      }}>
                        <span>Close</span>
                        <svg role="img" styleName="icon-arrow">
                          <use xlinkHref="#icon-arrow-right"></use>
                        </svg>
                      </a>
                      {this.getCta(notice, id, noticeCta)}
                    </div>
                </div>
            </div>
          )
        })}
        <AdditionalNotice />
      </div>
    )
  }
}
